export const SET_CUSTOMER_DETAILS = "SET_CUSTOMER_DETAILS"

export function setCustomerDetails(customerDetails) {
  return {
    type: SET_CUSTOMER_DETAILS,
    payload: {
      customerDetails,
    }
  }
}